module.exports = __webpack_public_path__ + "static/img/09011C_1_2_R_20200626_fit.f465fd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/09011C_1_2_R_20200626_fit.png
// module id = s7IG
// module chunks = 0